import React, { Component } from 'react';

import Dialog from 'core/components/Dialog';
import Form from 'core/form/components/Form';
import Field from 'core/form/components/Field';
import { inject, observer } from 'mobx-react';
import { Button } from 'core/components';
import { TextArea } from 'core/form';
import Flex from 'core/components/Flex';

const fields = {
  comment: {
    name: 'comment',
    label: 'Comment',
    defaultValue: '',
    placeholder: 'Add a comment...'
  }
};

@inject('$auth', '$comments')
@Form({ fields, options: { name: 'Comment' } })
@observer
export default class CommentDialog extends Component {
  handleComment = ({ comment }) => {
    const { model, onComment, entityType, $auth, $comments, form } = this.props;

    $comments
      .saveNewComment({
        comment,
        entityType,
        entityId: model.id.startsWith?.('a') ? model.id.substr(1) : model.id,
        activeUser: $auth.activeUser
      })
      .then((commentModel) => {
        if (onComment) {
          onComment(commentModel);
        }

        form.setValue('comment', '');
      });
  };

  render() {
    const { isOpen, onClose, form } = this.props;
    const currentComment = form.getValues().comment;

    return (
      <Dialog title="Comment" isOpen={isOpen} onClose={onClose} top={100} width={450} position="fixed">
        <Dialog.Body>
          <Field name="comment" large showLabel={false} mb={0}>
            <TextArea fill rows={3} autoFocus autoGrow resize />
          </Field>
        </Dialog.Body>
        <Dialog.Footer justifyContent="space-between">
          <Flex width="100%" gap={1}>
            <Button flex={1} text="Cancel" onClick={onClose} />
            <Button
              flex={1}
              disabled={!currentComment || currentComment.length < 3}
              onClick={() => this.handleComment(form.getValues())}
              text="Save"
              minWidth="120px"
              intent="primary"
            />
          </Flex>
        </Dialog.Footer>
      </Dialog>
    );
  }
}
